import { createAction } from '@reduxjs/toolkit';
import { SurveyState } from './model';

enum SurveyAction {
  setSurveyFilterUserList = '@survey/setSurveyFilterUserList',
  setSurveyRegionsUserList = '@survey/setSurveyRegionsUserList',
  setSurveyUnitsUserList = '@survey/setSurveUnitsUserList',
  setSurveyDepartmentUserList = '@survey/setSurveyDepartmentUserList',
  setSurveyDivisionUserList = '@survey/setSurveyDivisionUserList',
  setSurveyPositionsUserList = '@survey/setSurveyPositionsUserList',
  setSurveyRestaurantsUserList = '@survey/setSurveyRestaurantsUserList',
  setSurveyLevelsUserList = '@survey/setSurveyLevelsUserList',
  setSurvey360ObjectsUserList = '@survey/setSurvey360ObjectsUserList',
  setSurveyStaffsUserList = '@survey/setSurveyStaffsUserList',
  clearFilterUserList = '@survey/clearFilterUserList',
  setDataParamsDefault = '@setDataParamsDefault',
  setUserListNullData = '@survey/setUserListNullData',
  setKeywordSearchStaff = '@survey/setKeywordSearchStaff',
}

const setSurveyFilterUserList = createAction<SurveyState['userListFilter']>(
  SurveyAction.setSurveyFilterUserList
);
const setSurveyRegionsUserList = createAction<SurveyState['regions']>(
  SurveyAction.setSurveyRegionsUserList
);

const setSurveyUnitsUserList = createAction<SurveyState['units']>(
  SurveyAction.setSurveyUnitsUserList
);

const setSurveyDepartmentUserList = createAction<SurveyState['departments']>(
  SurveyAction.setSurveyDepartmentUserList
);
const setSurveyDivisionUserList = createAction<SurveyState['divisions']>(
  SurveyAction.setSurveyDivisionUserList
);

const setSurveyPositionsUserList = createAction<SurveyState['positions']>(
  SurveyAction.setSurveyPositionsUserList
);
const setSurveyRestaurantsUserList = createAction<SurveyState['restaurants']>(
  SurveyAction.setSurveyRestaurantsUserList
);

const setSurveyLevelsUserList = createAction<SurveyState['levels']>(
  SurveyAction.setSurveyLevelsUserList
);

const setSurvey360ObjectsUserList = createAction<SurveyState['survey360Objects']>(
  SurveyAction.setSurvey360ObjectsUserList
);

const setSurveyStaffsUserList = createAction<SurveyState['staffs']>(
  SurveyAction.setSurveyStaffsUserList
);

const clearFilterUserList = createAction(SurveyAction.clearFilterUserList);

const setDataParamsDefault = createAction<SurveyState['dataParamsDefault']>(
  SurveyAction.setDataParamsDefault
);

const setUserListNullData = createAction<SurveyState['isUserListNullData']>(
  SurveyAction.setUserListNullData
);

const setKeywordSearchStaff = createAction<SurveyState['keywordSearchStaff']>(
  SurveyAction.setKeywordSearchStaff
);

export const surveyAction = {
  setSurveyFilterUserList,
  setSurveyRegionsUserList,
  setSurveyUnitsUserList,
  setSurveyDepartmentUserList,
  setSurveyPositionsUserList,
  setSurveyLevelsUserList,
  setSurvey360ObjectsUserList,
  setSurveyStaffsUserList,
  clearFilterUserList,
  setDataParamsDefault,
  setSurveyDivisionUserList,
  setSurveyRestaurantsUserList,
  setUserListNullData,
  setKeywordSearchStaff,
};
